import React from 'react';

import { Inline } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';

// Bulk create button group - used for both AI and non-AI bulk create
export const BulkCreateButtonGroup = () => {
	// Will have to check if bulk create is possible (no required fields on issues)
	const isDisabled = false;
	// Will have to check if bulk create endpoint has been called and is loading
	const isLoading = false;
	return (
		<Inline>
			<Button>Cancel</Button>
			<Button appearance="primary" isDisabled={isDisabled} isLoading={isLoading}>
				Create all
			</Button>
		</Inline>
	);
};
